<template>
  <div id="BalanceComponentGroup" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm" v-if="balances">
        <q-list class="buttons-list">
          <q-item
            v-for="item in balances"
            :key="item"
            clickable
            v-ripple
            :active="balance === item"
            @click="changeBalanceComponentSelecet(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section class="ellipsis">
              {{ $gettext(item.name) }}</q-item-section
            >
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <span v-for="item in balances" :key="item">
          <q-card-section v-if="balance === item" class="padding-crud">
            <crud-layout-search
              :ref="'crudLayoutSearch-' + item.name"
              :name="$gettext(item.name)"
              :interface="item.interface"
              :page="item.page"
              :id="id"
              clean-layout
            >
              <page-table
                slot="page-table"
                slot-scope="dataPageTable"
                v-bind="dataPageTable"
                @action-button="dataPageTable.actionButton"
                @show-message="dataPageTable.showMessage"
              >
                <jt-data-table
                  slot="table"
                  slot-scope="dataTable"
                  v-bind="dataTable"
                  singleselect
                  class="table-crud"
                  :row-buttons="true"
                  @selection="dataTable.selection"
                  @action-button="dataTable.actionButton"
                  @show-message="dataTable.showMessage"
                  @toggle-change="row"
                >
                </jt-data-table>
              </page-table>
            </crud-layout-search>
          </q-card-section>
        </span>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
const { CrudLayoutSearch, pageTable } = JtCrud
import LandfillBalancePage from './../landfillBalance/LandfillBalancePage'
import LandfillBalance from './../landfillBalance/LandfillBalance'

@Component({
  name: 'BalanceComponentGroup',
  components: {
    CrudLayoutSearch,
    pageTable,
    JtDataTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class BalanceComponentGroup extends Vue {
  balances = [];
  balance = '';
  indice = 0;

  row ({ props, newValue, col }) {
    this.$q
      .dialog({
        component: LandfillBalance,
        parent: this
      })
      .onOk(async () => {
        const param = { useDisponible: newValue, id: props.key }
        const { registros } = await repository.resolveLogic(
          'landfillBalance.changeUseDisponible',
          param
        )
      })
      .onCancel(() => {
        props.row.useDisponible = !newValue
      })
  }

  beforeMount () {
    this.balances = [
      {
        name: 'LANDFILL_BALANCE',
        interface: 'landfillBalance.pesquisar',
        page: LandfillBalancePage
      },
      {
        name: 'BALANCE_SERIAL',
        interface: 'balanceSerial.pesquisar',
        page: null
      },
      {
        name: 'BALANCE_MODEL',
        interface: 'balanceModel.pesquisar',
        page: null
      },
      {
        name: 'BALANCE_BRAND',
        interface: 'balanceBrand.pesquisar',
        page: null
      }
    ]
    this.balance = this.balances[0]
  }

  changeBalanceComponentSelecet (item) {
    this.balance = item
  }
}
export default BalanceComponentGroup
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#BalanceComponentGroup {
.buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }

::v-deep {
  .jt-crud-container {
    padding: 0%;
  }
}

.padding-crud{
     padding: 0px 10px 10px;
     margin-top: -15px;
   }

    .itemSelect{
     color: white;
     background: $secondary!important;
     border-left: 5px solid $dark!important;
     padding-left: 5%!imporant;
   }

   .item{
     background: white;
     font-weight: 500;
     padding-left: 10%;
     font-size: 1rem;
   }
 }
</style>
